export default "__VITE_ASSET__jUKt97Gf__"